<template lang="pug">
div.custom-attach(id="medstockdd")
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" attach="#medstockdd" offset-y max-height="280")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl(v-bind="attrs" v-on="on" :class="error ? 'error-border-menu' : 'border-menu'" flat outlined height="48" min-width="240")
        .d-flex.align-center.fill-height.px-4
          .text-sm.flex-grow-1.text-left(v-if="value") {{ value.name }}
          .text-sm.flex-grow-1.neutral500--text.text-left(v-else) Select medicine
          v-icon(size="24") $yzi-chevron-down
      div.text-xs.danger500--text.ml-3.mt-1.mb-2(v-show="error") This field is required
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus @input="queryChanged")
        v-divider
        template
          div.d-flex.align-center.px-4.py-3(@click="createMedicine")
            div.text-sm.flex-grow-1.font-semibold.neutral700--text.clickable.underline Create new medicine
          v-divider
        div.d-flex.justify-center(v-if="isFetching")
          v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in medicines")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-neutral300)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        v-divider
      template(v-if="next")
        div.d-flex.align-center.px-4.py-3.clickable(@click="fetchNext(next)")
          div.text-sm.font-semibold.flex-grow-1.info600--text.text-center Load more
      template(v-if="!medicines.length")
        .px-4.py-3 No results match
  .dialogs
    add-new-medicine-dialog(v-if="openDialog" :open.sync="openDialog" @closed="openDialog = false")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import AddNewMedicineDialog from '@/components/clinic/inventory/AddNewMedicineDialog.vue'

export default {
  components: { AddNewMedicineDialog },
  props: ['value', 'error'],
  data: () => ({
    isLoading: false,
    isFetching: false,
    openDialog: false,
    show: false,
    itemName: null,
    next: null,
    medicines: [],
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showCreateButton() {
      if (this.itemName) {
        return true
      }
      return false
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchMedicineList()
      } else {
        this.$emit('change')
        this.clearList()
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMedicineList () {
      this.isFetching = true
      let params = {
        page_size: 10,
        status: 'published'
      }
      if (this.itemName) { 
        params.search = this.itemName
        delete params.status
      }
      this.$axios.get(`/clinics/${this.company.slug}/medications`, { params })
        .then(resp => {
          this.medicines = resp.data.results
          this.next = resp.data.next
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchNext (next) {
      this.isFetching = true
      const url = new URL(next)
      const endpoint = next.replace(url.origin, '')
      this.$axios.get(endpoint)
        .then(resp => {
          this.medicines = [ ...this.medicines, ...resp.data.results]
          this.next = resp.data.next
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    queryChanged: debounce(function () {
      this.fetchMedicineList()
    }, 750),
    selectItem (item) {
      this.$emit('input', item)
      this.show = false
      this.itemName = ''
    },
    isItemDisabled(item) {
      return this.value && this.value.id === item.id
    },
    createMedicine () {
      this.show = false
      this.openDialog = true
    },
    clearList () {
      this.medicines = []
      this.next = null
    }
  }
}
</script>

<style lang="scss" scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.custom-attach {
  .v-menu__content {
    top: unset !important;
    left: unset !important;
  }
} 
</style>